import React, { useEffect } from 'react';
import SimpleAnimatedCounter from '../components/SimpleAnimatedCounter';

const About = () => {
  useEffect(() => {
    document.title = 'About Us - VReco Energy | Renewable Energy Leaders in Gujarat';
    
    // Handle hash navigation
    const handleHashNavigation = () => {
      const hash = window.location.hash;
      console.log('Hash navigation triggered:', hash);
      if (hash) {
        const element = document.querySelector(hash);
        console.log('Target element found:', element);
        if (element) {
          // Wait a bit longer to ensure page is fully rendered
          setTimeout(() => {
            const offsetTop = element.offsetTop - 100; // Account for fixed navbar
            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth'
            });
          }, 300);
        }
      }
    };

    // Handle hash on initial load
    setTimeout(handleHashNavigation, 100);

    // Handle hash changes
    window.addEventListener('hashchange', handleHashNavigation);
    
    // Initialize scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);
    
    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach(el => observer.observe(el));

    return () => {
      fadeElements.forEach(el => observer.unobserve(el));
      window.removeEventListener('hashchange', handleHashNavigation);
    };
  }, []);

  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>About VReco Energy</h1>
          <p>Pioneering sustainable energy solutions with excellence and innovation</p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="content-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text fade-in">
              <h2>Welcome to VReco Energy</h2>

              {/* 
              <p style={{ textAlign: 'justify' }}>At VR Group, we are dedicated to driving the future of energy through innovative infrastructure solutions. As a trusted leader in the sector, we take pride in delivering world-class projects that power communities, fuel industries, and strengthen economies.</p>
              
              <p style={{ textAlign: 'justify' }}>Founded in 2016 by Mr. Ramshibhai Goriya, VR Group has grown from a Civil Works and Earth Moving service provider into a well-recognized name in Gujarat's infrastructure landscape. Our commitment to excellence and innovation has enabled us to take on large-scale projects — most recently, the successful completion of a 90 MW wind farm for KP Green Energy Pvt. Ltd.</p>
              
              */}
              
              <h3>Our Journey</h3>
              
              <p style={{ textAlign: 'justify' }}>About VR Group, Founded in 2016 by <strong>Mr. Ramshibhai Goriya</strong>, VR Group has grown into a well-recognized name in Gujarat's infrastructure and renewable energy landscape. The company began operations in 2015, providing Civil Works and Earth Moving services with its own and hired fleet of vehicles.</p>
              
              <p style={{ textAlign: 'justify' }}>Over the years, we have expanded into the renewable energy sector — covering Solar, Wind, and Hybrid power projects — and recently completed a landmark 90 MW wind farm for KP Green Energy Pvt. Ltd.</p>

              <p style={{ textAlign: 'justify' }}>With over 9 years of experience and more than 3 years of successful large-scale project operations, VR Group has consistently exceeded expectations. Our diversification into fabrication, galvanizing, and renewable energy has driven phenomenal growth and positioned us as a key contributor to India's green energy transition.</p>

              <p style={{ textAlign: 'justify' }}>Through VRECO Energy, our commitment to sustainable infrastructure continues to strengthen, powering a cleaner and more resilient future.</p>
              
              <h3>Powering a Greener Tomorrow</h3>
              
              <p style={{ textAlign: 'justify' }}>At VR Group, we don't just build projects — we build the future of energy.</p>

              <p style={{ textAlign: 'justify' }}>From our early days in Civil Works and Earth Moving in 2015 to becoming a trusted name in renewable infrastructure, our journey has been driven by innovation, ambition, and impact.</p>

              <p style={{ textAlign: 'justify' }}>In just a few years, we've delivered landmark projects — including a 90 MW wind farm for KP Green Energy Pvt. Ltd. — and expanded into Solar, Wind, Hybrid power.</p>

              <p style={{ textAlign: 'justify' }}>Through VRECO Energy, we're at the forefront of India's green energy transition, delivering solutions that power communities, fuel industries, and create a sustainable tomorrow.</p>

              <p style={{ textAlign: 'justify' }}>VR Group — Where innovation meets impact.</p>
            
            </div>
            
            <div className="stats fade-in">
              <div className="stat-item">
                <SimpleAnimatedCounter end={2016} />
                <span className="stat-label">Founded</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={9} suffix="+" />
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={310} suffix="+" />
                <span className="stat-label">MW Completed</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={100} suffix="%" />
                <span className="stat-label">Client Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section" id="mission-vision">
        <div className="container">
          <h2 className="section-title fade-in">Our Mission & Vision</h2>
          <p className="section-subtitle fade-in">Driving progress and creating lasting value for a sustainable future</p>
          
          <div className="mission-vision">
            <div className="mv-card fade-in">
              <div className="mv-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>To lead the transition to a sustainable energy future by developing, operating, and optimizing innovative energy infrastructure solutions. We are dedicated to delivering reliable, efficient, and environmentally responsible energy systems that meet the evolving needs of our customers and communities.</p>
            </div>
            
            <div className="mv-card fade-in">
              <div className="mv-icon">🔮</div>
              <h3>Our Vision</h3>
              <p>By embracing innovation and sustainability, we aim to shape the energy landscape and inspire positive change for generations to come. We envision a world powered by clean, renewable energy that benefits all stakeholders.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Directors */}
      <section className="content-section">
        <div className="container">
          <h2 className="section-title fade-in">Our Leadership Team</h2>
          <p className="section-subtitle fade-in">Experienced directors guiding our vision and growth</p>
          
          <div className="directors-grid">
            <div className="director-card fade-in">
              <div className="director-image">
                <img src="/img/ramshibhai_goriya.png" alt="Mr. Ramshibhai Goriya" loading="lazy" decoding="async" />
              </div>
              <h3>Mr. Ramshibhai Goriya</h3>
              <p className="designation">Director</p>
              <p className="director-description">Founder and visionary leader who established VR GROUP in 2016 with extensive experience in renewable energy infrastructure development. Under his leadership, the company has grown from civil work and earth moving operations to become a recognized leader in Gujarat's renewable energy sector. His strategic vision and hands-on approach have been instrumental in establishing key partnerships and achieving phenomenal growth in the renewable energy industry.</p>
            </div>
            
            <div className="director-card fade-in">
              <div className="director-image">
                <img src="/img/deshurbhai_goriya.png" alt="Mr. Deshurbhai Goriya" loading="lazy" decoding="async" />
              </div>
              <h3>Mr. Deshurbhai Goriya</h3>
              <p className="designation">Director</p>
              <p className="director-description">Strategic director with comprehensive expertise in operations and project management across the renewable energy sector. He brings valuable experience in overseeing complex infrastructure projects and ensuring operational excellence throughout all phases of development. Mr. Deshur plays a pivotal role in resource management, team coordination, and implementing best practices that have contributed to the company's impressive track record of successful project completions.</p>
            </div>
            
            <div className="director-card fade-in">
              <div className="director-image">
                <img src="/img/jayeshbhai_goriya.jpg" alt="Mr. Jayeshbhai Goriya" loading="lazy" decoding="async" />
              </div>
              <h3>Mr. Jayeshbhai Goriya</h3>
              <p className="designation">Director</p>
              <p className="director-description">Director specializing in business development and cultivating strong client relationships across renewable energy projects and strategic partnerships. His expertise in market analysis and business strategy has been instrumental in identifying new growth opportunities and expanding the company's presence in the renewable energy sector. Mr. Jayeshbhai excels in building long-term relationships with key stakeholders, including major clients like KP Green Energy, CLP India, and BA Prerna Renewables.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Directors Message */}
      <section className="section" style={{ display: 'none' }}>
        <div className="container">
          <h3 className="fade-in" style={{ fontSize: '1.8rem', color: '#1565C0', marginBottom: '2rem', textAlign: 'center' }}>Directors Message</h3>
          <div className="fade-in">
            <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '1.5rem', color: '#555', textAlign: 'justify' }}>
              We are committed to our customers and we are confident that with your continued support and enthusiasm, we will reach new heights. Our focus remains on continuous work to enhance our processes, embrace new technologies, and foster an environment where every team member can thrive.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#555', textAlign: 'justify' }}>
              This vision has guided us through both challenges and successes, and we are proud to say that, together, we have not only met but exceeded our goals. Our innovative ideas, collaborative spirit, and unwavering support of our customers have been the cornerstone of our achievements.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="content-section">
        <div className="container">
          <h2 className="section-title fade-in">Our Team</h2>
          <p className="section-subtitle fade-in">Dedicated professionals driving our mission forward</p>
          
          <div className="team-content fade-in">
            <div className="team-description">
              <p>Our success is built on the foundation of our exceptional team. We bring together talented professionals from diverse backgrounds, each contributing their unique expertise to create innovative energy solutions. From engineers and project managers to operations specialists and support staff, every team member plays a vital role in our continued growth and success.</p>
            </div>
            
            <div className="team-members-grid">
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">BG</div>
                </div>
                <div className="member-info">
                  <h3>Bhavesh Gupta</h3>
                  <p className="member-role">Company Advisor</p>
                  <p className="member-description">Strategic advisor providing guidance on company operations and growth initiatives.</p>
                </div>
              </div>
              
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">SD</div>
                </div>
                <div className="member-info">
                  <h3>Sandeep Dhandhukiya</h3>
                  <p className="member-role">Business Development</p>
                  <p className="member-description">Focused on expanding business opportunities and building strategic partnerships.</p>
                </div>
              </div>
              
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">PD</div>
                </div>
                <div className="member-info">
                  <h3>Paresh Davda</h3>
                  <p className="member-role">Administration & Site Office Incharge</p>
                  <p className="member-description">Managing administrative operations and overseeing site office coordination.</p>
                </div>
              </div>
              
                       
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">DB</div>
                </div>
                <div className="member-info">
                  <h3>Dinesh Baidiyavadara</h3>
                  <p className="member-role">Civil Engineering Head</p>
                  <p className="member-description">Leading civil engineering operations and overseeing infrastructure development for renewable energy projects.</p>
                </div>
              </div>

              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">NV</div>
                </div>
                <div className="member-info">
                  <h3>Naren Varsakiya</h3>
                  <p className="member-role">Business Support Head</p>
                  <p className="member-description">Providing essential business support services and operational assistance.</p>
                </div>
              </div>
              
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">RG</div>
                </div>
                <div className="member-info">
                  <h3>Raju Goriya</h3>
                  <p className="member-role">Electrical Engineering Head</p>
                  <p className="member-description">Expert in electrical systems design and implementation for energy infrastructure projects.</p>
                </div>
              </div>
              
             
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">HM</div>
                </div>
                <div className="member-info">
                  <h3>Hemant Madam</h3>
                  <p className="member-role">Land Acquisition Head</p>
                  <p className="member-description">Specialist in land surveying and acquisition for renewable energy projects.</p>
                </div>
              </div>
              
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">BM</div>
                </div>
                <div className="member-info">
                  <h3>Bharat Madam</h3>
                  <p className="member-role">Marketing Head</p>
                  <p className="member-description">Leading marketing initiatives and developing strategic promotional campaigns for business growth.</p>
                </div>
              </div>
              
              <div className="team-member-card fade-in">
                <div className="member-avatar">
                  <div className="avatar-placeholder">AN</div>
                </div>
                <div className="member-info">
                  <h3>Arjun Nandaniya</h3>
                  <p className="member-role">Transport & Logistics</p>
                  <p className="member-description">Ensuring efficient transport and logistics coordination across all projects.</p>
                </div>
              </div>
            </div>
            
            <div className="team-stats fade-in">
              <div className="stat-item">
                <SimpleAnimatedCounter end={50} suffix="+" />
                <span className="stat-label">Team Members</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={15} suffix="+" />
                <span className="stat-label">Engineers</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={3} suffix="+" />
                <span className="stat-label">Project Managers</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={95} suffix="%" />
                <span className="stat-label">Employee Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Commitment */}
      <section className="section why-choose">
        <div className="container">
          <h2 className="section-title fade-in" style={{ color: 'white' }}>Our Core Values & Commitment</h2>
          <p className="section-subtitle fade-in" style={{ color: 'rgba(255,255,255,0.9)' }}>The principles that guide our every decision and action</p>
          
          <div className="features-grid">
            <div className="feature-item fade-in">
              <div className="feature-icon">💡</div>
              <h3>Innovation</h3>
              <p>We leverage cutting-edge technology and forward-thinking approaches to develop energy infrastructure that meets the demands of today and tomorrow.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">⚙️</div>
              <h3>Reliability & Efficiency</h3>
              <p>Our projects are designed and executed with a focus on reliability and operational efficiency, ensuring uninterrupted service and optimal performance.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">🌱</div>
              <h3>Sustainability</h3>
              <p>We are dedicated to advancing sustainable energy practices. Our solutions prioritize environmental responsibility and contribute to a greener future.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">🤝</div>
              <h3>Customer-Centric Approach</h3>
              <p>Working in partnership with our clients to deliver exceptional outcomes through the application of design, consultancy, engineering, and project management services.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">🔗</div>
              <h3>Strategic Partnerships</h3>
              <p>We believe in building strong, long-term relationships with our partners, clients, and stakeholders to achieve mutual success and growth.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">📈</div>
              <h3>Long-Term Value</h3>
              <p>Our commitment extends beyond project completion. We focus on creating sustainable value that benefits all stakeholders for years to come.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Diversity & Inclusion */}
      <section className="content-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text fade-in">
              <h2>Diversity & Inclusion</h2>
              <p>"We believe that by working together, diverse people with different experiences conceive some of the most innovative ideas. Diversity hones our competitive edge and contributes to our company's strength."</p>
              
              <p>VRECO ENERGY actively promotes inclusiveness across the workplace, creating an environment where each individual has equal opportunity to achieve his or her full potential, where human differences are valued, and where employees feel respected and empowered in the decisions that affect them.</p>
              
              <p>A diverse and skilled workforce is essential to our success. We are committed to fostering an inclusive culture that celebrates different perspectives, backgrounds, and experiences, leading to better decision-making and innovation.</p>
            </div>
            
            <div className="fade-in">
              <div className="mv-card">
                <div className="mv-icon">👥</div>
                <h3>Our Team Philosophy</h3>
                <p>Excellence through diversity, innovation through collaboration, and success through mutual respect and shared values.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Growth Story */}
      <section className="section">
        <div className="container">
          <h2 className="section-title fade-in">Our Growth Story</h2>
          <p className="section-subtitle fade-in">A journey of transformation and excellence in renewable energy</p>
          
          <div className="growth-timeline fade-in">
            <div className="timeline-item left visible">
              <div className="timeline-year">2015</div>
              <div className="timeline-content">
                <h3>Foundation Years</h3>
                <p>VR GROUP began operations as a Civil Work & Earth Moving service provider with owned & hired fleet of vehicles, establishing the foundation for future growth.</p>
              </div>
            </div>
            
            <div className="timeline-item right visible">
              <div className="timeline-year">2016</div>
              <div className="timeline-content">
                <h3>Official Establishment</h3>
                <p>VR GROUP was officially founded by Mr. Ramshibhai Goriya, marking the beginning of our structured approach to renewable energy infrastructure.</p>
              </div>
            </div>
            
            <div className="timeline-item left visible">
              <div className="timeline-year">2018</div>
              <div className="timeline-content">
                <h3>Renewable Energy Focus</h3>
                <p>Strategic pivot towards renewable energy sector with focus on Solar, Wind & Hybrid power projects, establishing our expertise in clean energy solutions.</p>
              </div>
            </div>
            
            <div className="timeline-item right visible">
              <div className="timeline-year">2022</div>
              <div className="timeline-content">
                <h3>Major Project Milestone</h3>
                <p>The 90 MW wind farm started under KP Green Energy, marking a significant milestone in our renewable energy project capabilities.</p>
              </div>
            </div>
            
            <div className="timeline-item left visible">
              <div className="timeline-year">2023</div>
              <div className="timeline-content">
                <h3>150 MW Project Portfolio</h3>
                <p>Secured and initiated 150 MW ongoing wind farm project, further solidifying our position as a leading renewable energy infrastructure provider.</p>
              </div>
            </div>
            
            <div className="timeline-item right visible">
              <div className="timeline-year">2024</div>
              <div className="timeline-content">
                <h3>Industry Recognition</h3>
                <p>Achieved phenomenal growth with 310+ MW completed projects and established ourselves as a well-recognized group in Gujarat's renewable energy sector.</p>
              </div>
            </div>
            
            <div className="timeline-item left visible">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h3>Hybrid Project</h3>
                <p>Started 72 MW portion of 486 MW hybrid wind project in partnership with Torrent Power Ltd & Suzlon Ltd, showcasing our collaborative approach.</p>
              </div>
            </div>
            
            <div className="timeline-item right visible">
              <div className="timeline-year">Future</div>
              <div className="timeline-content">
                <h3>Our Future Vision</h3>
                <p>Continuing our commitment to India's green energy transition with innovative solutions and sustainable infrastructure development for generations to come.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality & Excellence */}
      <section className="section">
        <div className="container">
          <h2 className="section-title fade-in">Quality and Excellence in Execution</h2>
          <p className="section-subtitle fade-in">Our unwavering commitment to delivering exceptional results</p>
          
          <div className="about-content">
            <div className="about-text fade-in">
              <p>At VReco Energy, we specialize in creating robust, reliable, and sustainable infrastructure to support the full lifecycle of energy projects, including wind turbine generators (WTGs) and other energy infrastructure.</p>
              
              <p>We are dedicated to achieving client satisfaction by delivering projects that not only meet but exceed expectations, building enduring relationships through our commitment to excellence.</p>
              
              <p>Our quality assurance processes ensure that every project adheres to the highest standards of safety, efficiency, and environmental responsibility.</p>
            </div>
            
            <div className="stats fade-in">
              <div className="stat-item">
                <SimpleAnimatedCounter end={100} suffix="%" />
                <span className="stat-label">Quality Assurance</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={24} suffix="/7" />
                <span className="stat-label">Support</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={0} />
                <span className="stat-label">Safety Incidents</span>
              </div>
              <div className="stat-item">
                <SimpleAnimatedCounter end={99} suffix="%" />
                <span className="stat-label">Uptime</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;